import React from 'react';
import { PageExtensionSDK } from '../../../extensions-sdk';
import InsightBox from './InsightBox';
import localClient from '../../../utils/localClient';
import { getAllEntries } from '../../../utils/helpers';

interface Props {
  sdk: PageExtensionSDK;
  divider: boolean;
}

interface State {
  entryCount: number;
  loading: boolean;
}

export default class EntriesTranslated extends React.Component<Props, State> {
  state: State = {
    entryCount: 0,
    loading: true,
  };

  async componentDidMount() {
    const { sdk } = this.props;
    //@ts-ignore
    const translationProjectContentType = sdk.parameters.installation.translationsModelId;
    // get all translation projects in the space
    const query = {
      content_type: translationProjectContentType,
    };
    let translationProjectIds: string[] = (await getAllEntries(sdk, 0, query)).map(
      (e: any) => e.sys.id,
    );

    let translatedEntriesInfo = await localClient.getTranslatedEntriesInfo({
      translationProjectIds,
    });
    this.setState({
      entryCount: translatedEntriesInfo.entryCount,
      loading: false,
    });
  }

  render() {
    return (
      <InsightBox
        stat={this.state.entryCount + ''}
        text={'Entries Translated'}
        divider={this.props.divider}
        loading={this.state.loading}
      />
    );
  }
}
